import { render, staticRenderFns } from "./doPay.vue?vue&type=template&id=10a84db4&scoped=true"
import script from "./doPay.vue?vue&type=script&lang=js"
export * from "./doPay.vue?vue&type=script&lang=js"
import style0 from "./doPay.vue?vue&type=style&index=0&id=10a84db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a84db4",
  null
  
)

export default component.exports